/* DepositRefundList.js — استرداد سپرده (برگه استرداد) */
import React, { useState, useEffect, useCallback, useRef } from 'react';
import { TabBar } from '../TabManager';
import JalaliDatePicker from '../../components/JalaliDatePicker';
import useColumnResize from '../../hooks/useColumnResize';
import useTablePagination from '../../hooks/useTablePagination';
import RefundDetailPage from './RefundDetailPage';
import { useFormButtons } from '../../utils/vbPerms';
import { jsonOf, netErr } from '../../utils/http';

/* ── کمکی‌ها ── */
const toFa   = n => n===null||n===undefined?'':String(n).replace(/[0-9]/g,d=>'۰۱۲۳۴۵۶۷۸۹'[d]);
const numFmt = n => { const v=Number(n||0); return v===0?'':v.toLocaleString('fa-IR'); };
const API    = (path,opts={}) => fetch(`/api/deposit${path}`,{
  headers:{'Content-Type':'application/json',Authorization:`Bearer ${localStorage.getItem('access')}`},...opts,
}).then(jsonOf, netErr);

/* زیرکامپوننت‌ها بیرون — وگرنه فوکوس می‌پره */
const FInput = ({label,name,value,onChange,readOnly,flex=1,type='text',dir}) => (
  <div style={{display:'flex',flexDirection:'column',gap:'4px',flex}}>
    <label style={{fontSize:'12px',fontWeight:'600',color:'#555'}}>{label}</label>
    <input name={name} type={type} value={value??''} onChange={onChange} readOnly={readOnly}
      style={{padding:'8px 12px',border:'1.5px solid #e0e0e0',borderRadius:'8px',fontSize:'13px',
        fontFamily:"'Vazirmatn',Tahoma,sans-serif",outline:'none',
        direction:dir||'rtl',textAlign:dir==='ltr'?'left':'right',
        width:'100%',boxSizing:'border-box',background:readOnly?'#f5f5f5':'#fff'}}/>
  </div>
);

const FSelect = ({label,name,value,onChange,options,flex=1}) => (
  <div style={{display:'flex',flexDirection:'column',gap:'4px',flex}}>
    <label style={{fontSize:'12px',fontWeight:'600',color:'#555'}}>{label}</label>
    <select name={name} value={value??''} onChange={onChange}
      style={{padding:'8px 12px',border:'1.5px solid #e0e0e0',borderRadius:'8px',fontSize:'13px',
        fontFamily:"'Vazirmatn',Tahoma,sans-serif",outline:'none',direction:'rtl',
        width:'100%',boxSizing:'border-box',background:'#fff'}}>
      {options.map(o=><option key={o.value} value={o.value}>{o.label}</option>)}
    </select>
  </div>
);

const FDate = ({label,value,onChange,flex=1}) => (
  <div style={{display:'flex',flexDirection:'column',gap:'4px',flex}}>
    <label style={{fontSize:'12px',fontWeight:'600',color:'#555'}}>{label}</label>
    <JalaliDatePicker value={value} onChange={onChange} placeholder={label}/>
  </div>
);

const SCOPES = [
  {val:'all',        label:'همه'},
  {val:'device',     label:'ستاد'},
  {val:'departments',label:'واحدهای اجرایی'},
];
const STATES = [
  {val:'all',   label:'همه برگه‌ها'},
  {val:'open',  label:'فقط باز'},
  {val:'closed',label:'فقط بسته'},
];

/* ستون‌های گرید اصلی */
const INIT_WIDTHS = [45,80,70,140,130,120,70,100,110,105,105,120,130,130,240,120,90];

const EMPTY = {refund_no:'',refund_year:'',refund_amount:'',request_no:'',request_date:'',
  pay_date:'',receive_date:'',khz_request_date:'',khz_receive_date:''};

export default function DepositRefundList({ user, onBack }) {
  // دکمه‌های فرم FRMREFUNDNEW — دیدن = دسترسی
  const vbf = useFormButtons('FRMREFUNDNEW', ["BTNNEW","BTNEDIT","BTNDELETE","BTNCLOSE","BTNDETAIL1","BTNDETAIL2","BTNOK"]);
  /* ── گرید اصلی ── */
  const [rows,setRows]           = useState([]);
  const [total,setTotal]         = useState(0);
  const [sumAmount,setSumAmount] = useState(0);
  const [hasMore,setHasMore]     = useState(false);
  const [loading,setLoading]     = useState(false);
  const [selected,setSelected]   = useState(null);

  /* ── فیلترها ── */
  const [year,setYear]   = useState(0);
  const [scope,setScope] = useState('all');
  const [state,setState] = useState('all');
  const [years,setYears] = useState([]);
  const [ready,setReady] = useState(false);

  /* ── تنظیمات فرم از سرور ── */
  const [meta,setMeta] = useState({financial_year:0,next_refund_no:0,today:'',
    user_group_code:0,is_new_refund_allowed:true,show_scope:false});

  /* ── زیرگرید ریز استرداد ── */
  const [showDetail,setShowDetail] = useState(false);
  const [details,setDetails]       = useState([]);
  const [sumRefund,setSumRefund]   = useState(0);

  /* ── مودال‌ها ── */
  const [modal,setModal]   = useState(null);   // new | edit | delete | close | history
  const [form,setForm]     = useState(EMPTY);
  const [error,setError]   = useState('');
  const [warns,setWarns]   = useState([]);
  const [toast,setToast]   = useState('');
  const [password,setPassword] = useState('');

  /* ── پنل سابقه استرداد واحد اجرایی ── */
  const [hist,setHist]       = useState([]);
  const [histTotal,setHistTotal] = useState(0);
  const [hf,setHf]           = useState({department_id:0,department:'',from_date:'',to_date:'',
    taker:'',tel:'',melli_code:'',refund_pay:''});
  const [lookup,setLookup]   = useState([]);

  const offsetRef = useRef(0);

  /* ── ریز استرداد (دکمه‌های ۱ و ۲) — متن و نمایش از سرور (قاعدهٔ «خزانه») ── */
  const [detailBtns,setDetailBtns] = useState([]);
  const [rdKind,setRdKind]         = useState(0);
  useEffect(()=>{ API('/refunds/detail-buttons/').then(d=>{ if(d.ok) setDetailBtns(d.buttons||[]); }).catch(()=>{}); },[]);
  const openDetail = k => { if(selected && Number(selected.refund_no)!==0) setRdKind(k); };

  const {TH} = useColumnResize(INIT_WIDTHS);
  const {visibleRows,search,setSearch,totalCount,LoadMoreButton} = useTablePagination({
    allRows:rows, searchFields:['request_no','cheque_no','department','refund_no'],
    serverTotal:total, serverHasMore:hasMore,
  });

  const showToast = msg => { setToast(msg); setTimeout(()=>setToast(''),2800); };

  /* مقداردهی اولیه */
  useEffect(()=>{ (async()=>{
    try{
      const d = await API('/refunds/init/');
      if(d.ok){
        setMeta(d); setYears(d.years||[]); setYear(d.financial_year||0);
      }
    }catch(e){console.error(e);}
    setReady(true);
  })(); },[]);

  const fetchData = useCallback(async(reset=false)=>{
    if(reset){ offsetRef.current=0; setRows([]); setSelected(null); setDetails([]); }
    setLoading(true);
    try{
      const off = reset?0:offsetRef.current;
      const d = await API(`/refunds/?offset=${off}&year=${year}&scope=${scope}&state=${state}`);
      if(d.ok){
        setRows(p=>reset?d.rows:[...p,...d.rows]);
        setTotal(d.total); setSumAmount(d.sum_amount); setHasMore(d.has_more);
        offsetRef.current = (reset?0:offsetRef.current)+d.rows.length;
      }
    }catch(e){console.error(e);}
    setLoading(false);
  },[year,scope,state]);

  useEffect(()=>{ if(ready) fetchData(true); },[ready,year,scope,state]); // eslint-disable-line

  /* انتخاب ردیف → بارگذاری ریز استرداد */
  const selectRow = async r => {
    setSelected(r);
    if(!showDetail || r.detail_count===0){ setDetails([]); setSumRefund(0); return; }
    const d = await API(`/refunds/${r.id}/details/`);
    if(d.ok){ setDetails(d.rows); setSumRefund(d.sum_refund); }
  };
  useEffect(()=>{ if(selected) selectRow(selected); },[showDetail]); // eslint-disable-line

  const handleChange = e => { const{name,value}=e.target; setForm(p=>({...p,[name]:value})); };

  /* ── جدید / ویرایش ── */
  const openNew = ()=>{ if (!vbf.can('BTNNEW')) return;
    // کاربر ستاد وقتی مجوز ایجاد برگه بسته باشد نمی‌تواند برگه بسازد
    if(meta.user_group_code!==0 && !meta.is_new_refund_allowed){
      alert('امکان ایجاد برگه استرداد از سوی کاربر ستاد غیر مجاز شده است'); return;
    }
    setForm({...EMPTY, refund_no:meta.next_refund_no||'',
      refund_year:meta.financial_year||'', pay_date:meta.today||''});
    setError(''); setWarns([]); setModal('new');
  };
  const openEdit = ()=>{ if (!vbf.can('BTNEDIT')) return;
    if(!selected) return;
    if(!selected.can_edit){ alert('این برگه استرداد متعلق به گروه کاربری دیگری است'); return; }
    setForm({refund_no:selected.refund_no, refund_year:selected.refund_year,
      refund_amount:selected.refund_amount, request_no:selected.request_no,
      request_date:selected.request_date, pay_date:selected.pay_date,
      receive_date:selected.receive_date, khz_request_date:selected.khz_request_date,
      khz_receive_date:selected.khz_receive_date});
    setError(''); setWarns([]); setModal('edit');
  };

  /* اعتبارسنجی سمت کلاینت */
  const validate = f => {
    if(Number(f.refund_no||0)===0)   return 'شماره برگه استرداد وارد نشده است';
    if(Number(f.refund_year||0)===0) return 'سال استرداد وارد نشده است';
    return null;
  };

  const handleSave = async()=>{
    const v = validate(form);
    if(v){ setError(v); return; }
    setError(''); setWarns([]);
    const url = modal==='new' ? '/refunds/create/' : `/refunds/${selected.id}/update/`;
    const d = await API(url,{method:'POST',body:JSON.stringify(form)});
    if(d.ok){
      if(d.warnings?.length) showToast('⚠️ '+d.warnings[0]);
      else showToast(modal==='new'?'✅ ثبت شد':'✅ ویرایش شد');
      setModal(null); fetchData(true);
    } else setError(d.error||'خطا');
  };

  /* ── حذف — منع در صورت وجود ریز استرداد ── */
  const openDelete = ()=>{ if (!vbf.can('BTNDELETE')) return; if(!selected) return; setError(''); setModal('delete'); };
  const handleDelete = async()=>{
    const d = await API(`/refunds/${selected.id}/delete/`,{method:'POST'});
    if(d.ok){ setModal(null); setSelected(null); fetchData(true); showToast('✅ حذف شد'); }
    else setError(d.error||'خطا');
  };

  /* ── بستن / باز کردن برگه ── */
  const handleClose = async(pw)=>{
    if(!selected) return;
    const d = await API(`/refunds/${selected.id}/close/`,
      {method:'POST',body:JSON.stringify({password:pw||''})});
    if(d.ok){
      setModal(null); setPassword(''); fetchData(true);
      showToast(d.is_closed?'🔒 برگه بسته شد':'🔓 برگه باز شد');
    } else if(d.need_password){
      setError(d.error||''); setModal('close');
    } else { alert(d.error||'خطا'); }
  };
  const clickClose = ()=>{ if (!vbf.can('BTNCLOSE')) return;
    if(!selected) return;
    if(selected.is_closed){ setError(''); setPassword(''); setModal('close'); }
    else if(window.confirm('آيا مایل به بستن این برگه استرداد هستید؟')) handleClose();
  };

  /* ── سابقه استرداد واحد اجرایی ── */
  const openHistory = ()=>{ setHist([]); setHistTotal(0); setLookup([]); setModal('history'); };
  const fetchHistory = async()=>{
    const q = new URLSearchParams({department_id:hf.department_id||0,from_date:hf.from_date,
      to_date:hf.to_date,taker:hf.taker,tel:hf.tel,melli_code:hf.melli_code,
      refund_pay:hf.refund_pay||0}).toString();
    const d = await API(`/refunds/history/?${q}`);
    if(d.ok){ setHist(d.rows); setHistTotal(d.total); }
    else alert(d.error||'خطا');
  };
  const doLookup = async q => {
    const d = await API(`/departments/lookup/?q=${encodeURIComponent(q||'')}`);
    if(d.ok) setLookup(d.rows);
  };

  const yearOpts = [{value:0,label:'همه سال‌ها'},
    ...years.map(y=>({value:y,label:toFa(y)}))];

  return (
    <div style={s.page}>
      <header style={s.header}>
        <div style={s.hLeft}>
          <button onClick={onBack} style={s.backBtn}>← بازگشت</button>
          <div style={s.hLogo}><img src={require('../../assets/images/arjan.png')} alt="" style={{width:'34px',height:'34px',borderRadius:'7px'}}/></div>
          <div><div style={s.hTitle}>استرداد سپرده</div><div style={s.hSub}>برگه‌های استرداد — بخش سپرده</div></div>
        </div>
        <span style={s.userName}>{user?.full_name}</span>
      </header>
      <TabBar/>

      <main style={s.main}>
        {/* ── نوار ابزار ── */}
        <div style={s.toolbar}>
          <div style={s.toolBtns}>
            {vbf.can('BTNNEW') && <button onClick={openNew} style={s.btnNew}>＋ جدید</button>}
            {vbf.can('BTNEDIT') && <button onClick={openEdit} disabled={!selected} style={{...s.btnEdit,opacity:selected?1:.4}}>✎ ویرایش</button>}
            {vbf.can('BTNDELETE') && <button onClick={openDelete} disabled={!selected} style={{...s.btnDel,opacity:selected?1:.4}}>✕ حذف</button>}
            {detailBtns.filter(b=>b.visible).map(b=>(
              ((vbf.can('BTNDETAIL1') || vbf.can('BTNDETAIL2')) && <button key={b.key} onClick={()=>openDetail(b.kind)}
                disabled={!selected} style={{...s.btnDetail,opacity:selected?1:.4}}>📄 {b.text}</button>)))}
            {vbf.can('BTNCLOSE') && <button onClick={clickClose} disabled={!selected}
              style={{...s.btnClose,opacity:selected?1:.4}}>
              {selected?.is_closed?'🔓 باز کردن برگه':'🔒 بستن برگه'}</button>}
            <button onClick={openHistory} style={s.btnHist}>🔎 سابقه استرداد واحد اجرایی</button>
          </div>
          <label style={{...s.check,marginRight:'auto'}}>
            <input type="checkbox" checked={showDetail} onChange={e=>setShowDetail(e.target.checked)}/>
            <span>نمایش ریز استرداد</span>
          </label>
        </div>

        {/* ── فیلترها + جستجو ── */}
        <div style={s.toolbar2}>
          <div style={{width:'140px'}}>
            <FSelect label="سال" name="year" value={year}
              onChange={e=>setYear(Number(e.target.value))} options={yearOpts}/>
          </div>
          {meta.show_scope && (
            <div style={{display:'flex',gap:'12px',alignItems:'center',paddingBottom:'6px'}}>
              {SCOPES.map(m=>(
                <label key={m.val} style={s.radio}>
                  <input type="radio" name="scope" checked={scope===m.val} onChange={()=>setScope(m.val)}/>
                  <span>{m.label}</span>
                </label>))}
            </div>
          )}
          <div style={{display:'flex',gap:'12px',alignItems:'center',paddingBottom:'6px'}}>
            {STATES.map(m=>(
              <label key={m.val} style={s.radio}>
                <input type="radio" name="state" checked={state===m.val} onChange={()=>setState(m.val)}/>
                <span>{m.label}</span>
              </label>))}
          </div>
          <div style={{marginRight:'auto'}}>
            <div style={s.fL}>جستجو</div>
            <input value={search} onChange={e=>setSearch(e.target.value)}
              placeholder="شماره درخواست / شماره پرداخت / واحد اجرایی" style={{...s.fI,width:'280px'}}/>
          </div>
        </div>

        {/* ── گرید اصلی ── */}
        <div style={s.tableWrap}>
          <table style={{width:'100%',borderCollapse:'collapse',tableLayout:'fixed'}}>
            <thead style={{position:'sticky',top:0,zIndex:3}}>
              <tr>
                <TH idx={0}>ردیف</TH>
                <TH idx={1}>شماره</TH>
                <TH idx={2}>سال</TH>
                <TH idx={3} gold>مبلغ استرداد</TH>
                <TH idx={4} gold>جمع ریز</TH>
                <TH idx={5} gold>مانده</TH>
                <TH idx={6}>تعداد</TH>
                <TH idx={7}>درخواست</TH>
                <TH idx={8}>تاریخ</TH>
                <TH idx={9}>پرداخت</TH>
                <TH idx={10}>وصول</TH>
                <TH idx={11}>درخواست از خزانه</TH>
                <TH idx={12} green>دارای سند</TH>
                <TH idx={13} green>بدون سند</TH>
                <TH idx={14} right>واحد اجرایی/شهرستان</TH>
                <TH idx={15}>شماره پرداخت</TH>
                <TH idx={16}>باز/بسته</TH>
              </tr>
            </thead>
            <tbody>
              {visibleRows.length===0 && (
                <tr><td colSpan={17} style={s.empty}>
                  {loading?'در حال بارگذاری...':'اطلاعاتی برای نمایش وجود ندارد'}
                </td></tr>)}
              {visibleRows.map((r,idx)=>{
                const sel = selected?.id===r.id;
                const bg  = sel ? '#64b5f6'
                          : r.is_closed ? '#eceff1'
                          : r.remain!==0 ? '#fff8e1'
                          : idx%2===0 ? '#fff' : '#fdf6e3';
                return (
                  <tr key={r.id} onClick={()=>selectRow(r)} style={{cursor:'pointer',background:bg}}
                    onDoubleClick={()=>{ const b=detailBtns.find(x=>x.key==='btnDetail1'); if(b&&b.visible){ setSelected(r); setRdKind(b.kind); } }}
                    onMouseEnter={e=>{if(!sel)e.currentTarget.style.background='#bbdefb';}}
                    onMouseLeave={e=>{if(!sel)e.currentTarget.style.background=bg;}}>
                    <td style={s.td}>{toFa(idx+1)}</td>
                    <td style={{...s.td,fontWeight:'700'}}>{toFa(r.refund_no)}</td>
                    <td style={s.td}>{toFa(r.refund_year)}</td>
                    <td style={{...s.td,...s.num,color:'#6a1b9a'}}>{numFmt(r.refund_amount)}</td>
                    <td style={{...s.td,...s.num,color:'#1565c0'}}>{numFmt(r.detail_sum)}</td>
                    <td style={{...s.td,...s.num,color:r.remain!==0?'#e65100':'#999'}}>{numFmt(r.remain)}</td>
                    <td style={s.td}>{toFa(r.detail_count)}</td>
                    <td style={s.td}>{toFa(r.request_no)}</td>
                    <td style={{...s.td,direction:'ltr'}}>{toFa(r.request_date)}</td>
                    <td style={{...s.td,direction:'ltr'}}>{toFa(r.pay_date)}</td>
                    <td style={{...s.td,direction:'ltr'}}>{toFa(r.receive_date)}</td>
                    <td style={{...s.td,direction:'ltr'}}>{toFa(r.khz_request_date)}</td>
                    <td style={{...s.td,...s.num,color:'#00695c'}}>{numFmt(r.with_document)}</td>
                    <td style={{...s.td,...s.num,color:'#8d6e63'}}>{numFmt(r.without_document)}</td>
                    <td style={{...s.td,textAlign:'right'}} title={r.department}>{r.department}</td>
                    <td style={{...s.td,direction:'ltr'}}>{toFa(r.cheque_no)}</td>
                    <td style={s.td}>{r.is_closed
                      ? <span style={{color:'#c62828',fontWeight:'700'}}>🔒 بسته</span>
                      : <span style={{color:'#1b5e20',fontWeight:'700'}}>باز</span>}</td>
                  </tr>);
              })}
            </tbody>
          </table>
        </div>
        <LoadMoreButton onClick={()=>fetchData(false)} loading={loading}/>

        {/* ── نوار جمع‌ها ── */}
        <div style={s.summary}>
          <span>تعداد: <b>{toFa(visibleRows.length)}</b> از <b>{toFa(totalCount)}</b></span>
          <span>جمع مبلغ استرداد: <b style={{color:'#6a1b9a'}}>{numFmt(sumAmount)||'۰'}</b> ریال</span>
          <span>سال مالی: <b>{toFa(meta.financial_year)}</b></span>
          {selected && <>
            <span>برگه انتخابی: <b>{toFa(selected.refund_no)}</b>/<b>{toFa(selected.refund_year)}</b></span>
            <span>تعداد ریز: <b>{toFa(selected.detail_count)}</b></span>
            <span>مانده: <b style={{color:selected.remain!==0?'#e65100':'#1b5e20'}}>{numFmt(selected.remain)||'۰'}</b></span>
          </>}
        </div>

        {/* ── زیرگرید ریز استرداد ── */}
        {showDetail && details.length>0 && (
          <div style={s.subWrap}>
            <div style={{...s.subTitle,background:'linear-gradient(135deg,#0d2137,#1a2f50)',color:'#C8A84B'}}>
              📄 ریز استرداد — جمع: {numFmt(sumRefund)} ریال
            </div>
            <table style={{width:'100%',borderCollapse:'collapse'}}>
              <thead><tr>
                {['بستانکاری','سال','ردیف سپرده','مبلغ سپرده','مبلغ استرداد','جمع کل استرداد ردیف',
                  'مانده ردیف','واحد اجرایی','گیرنده','کد ملی','شماره حساب','شماره پرداخت',
                  'تاریخ پرداخت','موضوع سپرده','پیمانکار','سند']
                  .map(h=><th key={h} style={s.subTh}>{h}</th>)}
              </tr></thead>
              <tbody>
                {details.map((r,idx)=>(
                  <tr key={r.id} style={{background:idx%2===0?'#fff':'#fffde7'}}>
                    <td style={s.subTd}>{toFa(r.credit_no)}</td>
                    <td style={s.subTd}>{toFa(r.credit_year)}</td>
                    <td style={s.subTd}>{toFa(r.credit_row)}</td>
                    <td style={{...s.subTd,...s.num,color:'#1b5e20'}}>{numFmt(r.detail_amount)}</td>
                    <td style={{...s.subTd,...s.num,color:'#6a1b9a'}}>{numFmt(r.refund_pay)}</td>
                    <td style={{...s.subTd,...s.num,color:'#1565c0'}}>{numFmt(r.total_of_row)}</td>
                    <td style={{...s.subTd,...s.num}}>{numFmt(r.row_remain)}</td>
                    <td style={{...s.subTd,textAlign:'right'}}>{r.department}</td>
                    <td style={{...s.subTd,textAlign:'right'}}>{r.taker}</td>
                    <td style={{...s.subTd,direction:'ltr'}}>{toFa(r.melli_code)}</td>
                    <td style={{...s.subTd,direction:'ltr',fontSize:'11px'}}>{r.account_no}</td>
                    <td style={{...s.subTd,direction:'ltr'}}>{toFa(r.cheque_no)}</td>
                    <td style={{...s.subTd,direction:'ltr'}}>{toFa(r.cheque_date)}</td>
                    <td style={{...s.subTd,textAlign:'right'}}>{r.subject}</td>
                    <td style={{...s.subTd,textAlign:'right'}}>{r.contractor}</td>
                    <td style={s.subTd}>{r.has_document?'✅':'—'}</td>
                  </tr>))}
              </tbody>
            </table>
          </div>
        )}
      </main>

      {/* ══ ریز استرداد ══ */}
      {rdKind>0 && selected && (
        <RefundDetailPage refundId={selected.id} kind={rdKind}
          onClose={()=>{ setRdKind(0); fetchData(true); }}/>
      )}

      {/* ══ مودال جدید / ویرایش ══ */}
      {(modal==='new'||modal==='edit') && (
        <div style={s.overlay} onClick={()=>setModal(null)}>
          <div style={s.modal} onClick={e=>e.stopPropagation()}>
            <div style={s.mHeader}>
              <div style={s.mTitle}>{modal==='new'?'➕ ثبت برگه استرداد جدید':'✎ ویرایش برگه استرداد'}</div>
              <button onClick={()=>setModal(null)} style={s.closeBtn}>✕</button>
            </div>
            <div style={s.mBody}>
              {error&&<div style={s.errBox}>{error}</div>}
              {warns.map((w,idx)=><div key={idx} style={s.warnBox}>⚠️ {w}</div>)}
              {Number(form.refund_year||0)!==0 && Number(form.refund_year)!==meta.financial_year && (
                <div style={s.warnBox}>⚠️ سال استرداد با سال مالی متفاوت است</div>)}
              <div style={s.row}>
                <FInput label="شماره برگه *" name="refund_no" value={form.refund_no}
                  onChange={handleChange} type="number" dir="ltr" flex="0 0 24%"/>
                <FInput label="سال *" name="refund_year" value={form.refund_year}
                  onChange={handleChange} type="number" dir="ltr" flex="0 0 20%"/>
                <FInput label="مبلغ استرداد" name="refund_amount" value={form.refund_amount}
                  onChange={handleChange} type="number" dir="ltr"
                  readOnly={meta.user_group_code>0} flex="0 0 52%"/>
              </div>
              <div style={s.row}>
                <FInput label="شماره درخواست" name="request_no" value={form.request_no}
                  onChange={handleChange} flex="0 0 32%"/>
                <FDate label="تاریخ درخواست" value={form.request_date}
                  onChange={v=>setForm(p=>({...p,request_date:v}))} flex="0 0 32%"/>
                <FDate label="تاریخ پرداخت" value={form.pay_date}
                  onChange={v=>setForm(p=>({...p,pay_date:v}))} flex="0 0 32%"/>
              </div>
              <div style={s.row}>
                <FDate label="تاریخ وصول" value={form.receive_date}
                  onChange={v=>setForm(p=>({...p,receive_date:v}))} flex="0 0 32%"/>
                <FDate label="درخواست از خزانه" value={form.khz_request_date}
                  onChange={v=>setForm(p=>({...p,khz_request_date:v}))} flex="0 0 32%"/>
                <FDate label="وصول از خزانه" value={form.khz_receive_date}
                  onChange={v=>setForm(p=>({...p,khz_receive_date:v}))} flex="0 0 32%"/>
              </div>
              {modal==='edit'&&selected?.detail_count>0&&(
                <div style={s.warnBox}>
                  ⚠️ این برگه {toFa(selected.detail_count)} ریز استرداد دارد؛
                  با تغییر شماره یا سال، ریز استردادها هم منتقل می‌شوند.
                </div>)}
              {modal==='edit'&&selected?.is_closed===1&&(
                <div style={s.warnBox}>🔒 این برگه بسته است؛ ریز استرداد آن قابل تغییر نیست.</div>)}
            </div>
            <div style={s.mFooter}>
              <button onClick={()=>setModal(null)} style={s.btnCancel}>لغو</button>
              {vbf.can('BTNOK') && <button onClick={handleSave} style={s.btnSave}>ثبت</button>}
            </div>
          </div>
        </div>
      )}

      {/* ══ مودال حذف ══ */}
      {modal==='delete'&&selected&&(
        <div style={s.overlay} onClick={()=>setModal(null)}>
          <div style={{...s.modal,maxWidth:'480px'}} onClick={e=>e.stopPropagation()}>
            <div style={{...s.mHeader,background:'linear-gradient(135deg,#b71c1c,#c62828)'}}>
              <div style={s.mTitle}>⚠️ تأیید حذف</div>
              <button onClick={()=>setModal(null)} style={s.closeBtn}>✕</button></div>
            <div style={s.mBody}>
              {error&&<div style={s.errBox}>{error}</div>}
              <p style={{fontSize:'14px',lineHeight:'2'}}>
                آیا از حذف برگه استرداد شماره <b>{toFa(selected.refund_no)}</b> سال <b>{toFa(selected.refund_year)}</b> به
                مبلغ <b>{numFmt(selected.refund_amount)}</b> ریال مطمئن هستید؟</p>
              {selected.detail_count>0&&<p style={{color:'#c62828',fontWeight:'700'}}>
                ⚠️ این برگ استرداد بدلیل وجود ریز استرداد قابل حذف نیست.</p>}
              {!selected.can_edit&&<p style={{color:'#c62828',fontWeight:'700'}}>
                ⚠️ این برگه استرداد متعلق به گروه کاربری دیگری است.</p>}
            </div>
            <div style={s.mFooter}>
              <button onClick={()=>setModal(null)} style={s.btnCancel}>لغو</button>
              {selected.detail_count===0&&selected.can_edit&&(vbf.can('BTNDELETE') && <button onClick={handleDelete}
                style={{...s.btnSave,background:'linear-gradient(135deg,#b71c1c,#c62828)'}}>حذف</button>)}
            </div>
          </div>
        </div>
      )}

      {/* ══ مودال باز کردن برگه (رمز ذیحساب) ══ */}
      {modal==='close'&&selected&&(
        <div style={s.overlay} onClick={()=>setModal(null)}>
          <div style={{...s.modal,maxWidth:'420px'}} onClick={e=>e.stopPropagation()}>
            <div style={{...s.mHeader,background:'linear-gradient(135deg,#e65100,#f57c00)'}}>
              <div style={s.mTitle}>🔓 باز کردن برگه استرداد</div>
              <button onClick={()=>setModal(null)} style={s.closeBtn}>✕</button></div>
            <div style={s.mBody}>
              {error&&<div style={s.errBox}>{error}</div>}
              <p style={{fontSize:'13px',lineHeight:'2',marginBottom:'12px'}}>
                برای باز کردن برگه شماره <b>{toFa(selected.refund_no)}</b> رمز ذیحساب را وارد کنید.</p>
              <FInput label="رمز ذیحساب" name="password" value={password} type="password"
                onChange={e=>setPassword(e.target.value)} dir="ltr"/>
            </div>
            <div style={s.mFooter}>
              <button onClick={()=>setModal(null)} style={s.btnCancel}>لغو</button>
              {vbf.can('BTNCLOSE') && <button onClick={()=>handleClose(password)} disabled={!password.trim()}
                style={{...s.btnSave,opacity:password.trim()?1:.4,
                  background:'linear-gradient(135deg,#e65100,#f57c00)'}}>تأیید</button>}
            </div>
          </div>
        </div>
      )}

      {/* ══ مودال سابقه استرداد واحد اجرایی ══ */}
      {modal==='history'&&(
        <div style={s.overlay} onClick={()=>{setModal(null);setLookup([]);}}>
          <div style={{...s.modal,maxWidth:'1100px'}} onClick={e=>e.stopPropagation()}>
            <div style={{...s.mHeader,background:'linear-gradient(135deg,#37474f,#455a64)'}}>
              <div style={s.mTitle}>🔎 سابقه استرداد واحد اجرایی</div>
              <button onClick={()=>{setModal(null);setLookup([]);}} style={s.closeBtn}>✕</button></div>
            <div style={s.mBody}>
              <div style={s.row}>
                <div style={{flex:'0 0 32%',display:'flex',flexDirection:'column',gap:'4px',position:'relative'}}>
                  <label style={{fontSize:'12px',fontWeight:'600',color:'#555'}}>واحد اجرایی</label>
                  <input value={hf.department} placeholder="تایپ کنید..."
                    onChange={e=>{setHf(p=>({...p,department:e.target.value,department_id:0}));doLookup(e.target.value);}}
                    onFocus={()=>doLookup(hf.department)} style={s.fI}/>
                  {lookup.length>0&&(
                    <div style={s.dropdown}>{lookup.map(r=>(
                      <div key={r.id} onClick={()=>{setHf(p=>({...p,department_id:r.id,department:r.title}));setLookup([]);}}
                        style={s.dropItem}>{toFa(r.code)} — {r.title}</div>))}</div>)}
                </div>
                <FDate label="از تاریخ چک" value={hf.from_date}
                  onChange={v=>setHf(p=>({...p,from_date:v}))} flex="0 0 32%"/>
                <FDate label="تا تاریخ چک" value={hf.to_date}
                  onChange={v=>setHf(p=>({...p,to_date:v}))} flex="0 0 32%"/>
              </div>
              <div style={s.row}>
                <FInput label="گیرنده" name="taker" value={hf.taker}
                  onChange={e=>setHf(p=>({...p,taker:e.target.value}))} flex="0 0 24%"/>
                <FInput label="تلفن" name="tel" value={hf.tel}
                  onChange={e=>setHf(p=>({...p,tel:e.target.value}))} dir="ltr" flex="0 0 20%"/>
                <FInput label="کد ملی" name="melli_code" value={hf.melli_code}
                  onChange={e=>setHf(p=>({...p,melli_code:e.target.value}))} dir="ltr" flex="0 0 20%"/>
                <FInput label="مبلغ استرداد" name="refund_pay" value={hf.refund_pay}
                  onChange={e=>setHf(p=>({...p,refund_pay:e.target.value}))} type="number" dir="ltr" flex="0 0 24%"/>
                <div style={{display:'flex',alignItems:'flex-end',flex:'0 0 8%'}}>
                  <button onClick={fetchHistory} style={s.btnShow}>🔍</button>
                </div>
              </div>
              <div style={{fontSize:'12px',color:'#555',marginBottom:'8px'}}>
                تعداد: <b>{toFa(histTotal)}</b>
              </div>
              <div style={{overflow:'auto',maxHeight:'46vh'}}>
                <table style={{width:'100%',borderCollapse:'collapse'}}>
                  <thead><tr>
                    {['واحد اجرایی','سال بستانکاری','بستانکاری','ردیف سپرده','مبلغ سپرده','قبض','تاریخ',
                      'تعداد استرداد','جمع کل استرداد','مبلغ استرداد','شماره استرداد','سال استرداد',
                      'شماره درخواست','تاریخ درخواست','گیرنده','تلفن','کد ملی','شماره حساب',
                      'شماره پرداخت','تاریخ پرداخت','ملاحظات']
                      .map(h=><th key={h} style={s.subTh}>{h}</th>)}
                  </tr></thead>
                  <tbody>
                    {hist.length===0&&<tr><td colSpan={21} style={s.empty}>اطلاعاتی نیست</td></tr>}
                    {hist.map((r,idx)=>(
                      <tr key={r.id} style={{background:idx%2===0?'#fff':'#eceff1'}}>
                        <td style={{...s.subTd,textAlign:'right'}}>{r.department}</td>
                        <td style={s.subTd}>{toFa(r.credit_year)}</td>
                        <td style={s.subTd}>{toFa(r.credit_no)}</td>
                        <td style={s.subTd}>{toFa(r.credit_row)}</td>
                        <td style={{...s.subTd,...s.num,color:'#1b5e20'}}>{numFmt(r.detail_amount)}</td>
                        <td style={{...s.subTd,direction:'ltr'}}>{toFa(r.slip_no)}</td>
                        <td style={{...s.subTd,direction:'ltr'}}>{toFa(r.slip_date)}</td>
                        <td style={s.subTd}>{toFa(r.refund_count)}</td>
                        <td style={{...s.subTd,...s.num,color:'#1565c0'}}>{numFmt(r.total_refund)}</td>
                        <td style={{...s.subTd,...s.num,color:'#6a1b9a'}}>{numFmt(r.refund_pay)}</td>
                        <td style={s.subTd}>{toFa(r.refund_no)}</td>
                        <td style={s.subTd}>{toFa(r.refund_year)}</td>
                        <td style={s.subTd}>{toFa(r.request_no)}</td>
                        <td style={{...s.subTd,direction:'ltr'}}>{toFa(r.request_date)}</td>
                        <td style={{...s.subTd,textAlign:'right'}}>{r.taker}</td>
                        <td style={{...s.subTd,direction:'ltr'}}>{toFa(r.taker_tel)}</td>
                        <td style={{...s.subTd,direction:'ltr'}}>{toFa(r.melli_code)}</td>
                        <td style={{...s.subTd,direction:'ltr',fontSize:'11px'}}>{r.account_no}</td>
                        <td style={{...s.subTd,direction:'ltr'}}>{toFa(r.cheque_no)}</td>
                        <td style={{...s.subTd,direction:'ltr'}}>{toFa(r.cheque_date)}</td>
                        <td style={{...s.subTd,textAlign:'right'}} title={r.remark}>{r.remark}</td>
                      </tr>))}
                  </tbody>
                </table>
              </div>
            </div>
            <div style={s.mFooter}>
              <button onClick={()=>{setModal(null);setLookup([]);}} style={s.btnCancel}>بستن</button>
            </div>
          </div>
        </div>
      )}

      {toast&&<div style={s.toast}>{toast}</div>}
    </div>
  );
}

const s = {
  page:{height:'100vh',overflow:'hidden',background:'#f0f2f7',fontFamily:"'Vazirmatn',Tahoma,sans-serif",direction:'rtl',display:'flex',flexDirection:'column'},
  header:{background:'linear-gradient(135deg,#0a1628,#1a2f50)',padding:'10px 24px',display:'flex',justifyContent:'space-between',alignItems:'center',boxShadow:'0 2px 16px rgba(0,0,0,0.3)',flexShrink:0},
  hLeft:{display:'flex',alignItems:'center',gap:'12px'},
  backBtn:{padding:'6px 14px',background:'rgba(255,255,255,0.12)',color:'#fff',border:'1px solid rgba(255,255,255,0.25)',borderRadius:'7px',cursor:'pointer',fontFamily:'inherit',fontSize:'13px'},
  hLogo:{width:'40px',height:'40px',background:'rgba(200,168,75,0.12)',border:'1px solid rgba(200,168,75,0.3)',borderRadius:'9px',display:'flex',alignItems:'center',justifyContent:'center'},
  hTitle:{fontSize:'15px',fontWeight:'700',color:'#fff'},
  hSub:{fontSize:'11px',color:'rgba(255,255,255,0.55)'},
  userName:{fontSize:'13px',color:'rgba(255,255,255,0.85)'},
  main:{padding:'8px 20px',flex:1,display:'flex',flexDirection:'column',overflow:'auto',minHeight:0},
  toolbar:{display:'flex',alignItems:'center',gap:'8px',background:'#fff',padding:'8px 14px',borderRadius:'10px',boxShadow:'0 1px 6px rgba(0,0,0,0.08)',marginBottom:'6px',flexWrap:'wrap',flexShrink:0},
  toolbar2:{display:'flex',alignItems:'flex-end',gap:'14px',background:'#fff',padding:'8px 14px',borderRadius:'10px',boxShadow:'0 1px 6px rgba(0,0,0,0.08)',marginBottom:'6px',flexWrap:'wrap',flexShrink:0},
  toolBtns:{display:'flex',gap:'7px',flexWrap:'wrap'},
  check:{display:'flex',alignItems:'center',gap:'6px',fontSize:'12px',fontWeight:'600',color:'#444',cursor:'pointer'},
  radio:{display:'flex',alignItems:'center',gap:'5px',fontSize:'12px',fontWeight:'600',color:'#444',cursor:'pointer'},
  fL:{fontSize:'11px',fontWeight:'600',color:'#555',marginBottom:'3px'},
  fI:{padding:'8px 12px',border:'1.5px solid #e0e0e0',borderRadius:'8px',fontSize:'13px',fontFamily:"'Vazirmatn',Tahoma,sans-serif",outline:'none',direction:'rtl',textAlign:'right',boxSizing:'border-box',width:'100%'},
  btnNew:{padding:'7px 16px',background:'linear-gradient(135deg,#1b5e20,#2e7d32)',color:'#fff',border:'none',borderRadius:'8px',cursor:'pointer',fontFamily:'inherit',fontSize:'13px',fontWeight:'700'},
  btnEdit:{padding:'7px 16px',background:'linear-gradient(135deg,#1a237e,#283593)',color:'#fff',border:'none',borderRadius:'8px',fontFamily:'inherit',fontSize:'13px',fontWeight:'700',cursor:'pointer'},
  btnDel:{padding:'7px 16px',background:'linear-gradient(135deg,#b71c1c,#c62828)',color:'#fff',border:'none',borderRadius:'8px',fontFamily:'inherit',fontSize:'13px',fontWeight:'700',cursor:'pointer'},
  btnDetail:{padding:'7px 16px',background:'linear-gradient(135deg,#4a148c,#6a1b9a)',color:'#fff',border:'none',borderRadius:'8px',fontFamily:'inherit',fontSize:'13px',fontWeight:'700',cursor:'pointer'},
  btnClose:{padding:'7px 16px',background:'linear-gradient(135deg,#e65100,#f57c00)',color:'#fff',border:'none',borderRadius:'8px',fontFamily:'inherit',fontSize:'13px',fontWeight:'700',cursor:'pointer'},
  btnHist:{padding:'7px 16px',background:'linear-gradient(135deg,#37474f,#455a64)',color:'#fff',border:'none',borderRadius:'8px',fontFamily:'inherit',fontSize:'13px',fontWeight:'700',cursor:'pointer'},
  btnShow:{padding:'8px 14px',background:'linear-gradient(135deg,#37474f,#455a64)',color:'#fff',border:'none',borderRadius:'8px',cursor:'pointer',fontFamily:'inherit',fontSize:'14px',fontWeight:'700'},
  tableWrap:{overflowX:'auto',overflowY:'auto',borderRadius:'10px',boxShadow:'0 2px 8px rgba(0,0,0,0.1)',background:'#fff',flex:1,minHeight:'260px'},
  td:{padding:'6px 8px',borderBottom:'1px solid #f0f0f0',textAlign:'center',fontSize:'12px',whiteSpace:'nowrap',overflow:'hidden',textOverflow:'ellipsis'},
  num:{direction:'ltr',textAlign:'left',fontWeight:'700'},
  empty:{textAlign:'center',padding:'40px',color:'#999',fontSize:'13px'},
  summary:{display:'flex',gap:'20px',flexWrap:'wrap',background:'#fff',padding:'8px 14px',borderRadius:'10px',boxShadow:'0 1px 6px rgba(0,0,0,0.08)',margin:'6px 0',fontSize:'12px',color:'#444',flexShrink:0},
  subWrap:{background:'#fff',borderRadius:'10px',boxShadow:'0 1px 6px rgba(0,0,0,0.1)',marginBottom:'8px',overflow:'auto',flexShrink:0},
  subTitle:{padding:'7px 14px',fontSize:'12px',fontWeight:'700'},
  subTh:{padding:'7px 9px',background:'#0d2137',color:'#C8A84B',fontSize:'11px',fontWeight:'700',whiteSpace:'nowrap',position:'sticky',top:0,zIndex:2},
  subTd:{padding:'6px 8px',borderBottom:'1px solid #f0f0f0',textAlign:'center',fontSize:'12px',whiteSpace:'nowrap'},
  overlay:{position:'fixed',inset:0,background:'rgba(0,0,0,0.55)',zIndex:1000,display:'flex',alignItems:'center',justifyContent:'center',padding:'16px'},
  modal:{background:'#fff',borderRadius:'16px',width:'100%',maxWidth:'760px',maxHeight:'92vh',display:'flex',flexDirection:'column',boxShadow:'0 20px 60px rgba(0,0,0,0.4)'},
  mHeader:{display:'flex',justifyContent:'space-between',alignItems:'center',padding:'14px 20px',background:'linear-gradient(135deg,#0a1628,#1a2f50)',borderRadius:'16px 16px 0 0'},
  mTitle:{fontSize:'15px',fontWeight:'700',color:'#fff'},
  closeBtn:{background:'rgba(255,255,255,0.15)',border:'1px solid rgba(255,255,255,0.3)',color:'#fff',width:'30px',height:'30px',borderRadius:'50%',cursor:'pointer',fontSize:'13px',display:'flex',alignItems:'center',justifyContent:'center'},
  mBody:{overflowY:'auto',flex:1,padding:'18px'},
  mFooter:{display:'flex',justifyContent:'flex-end',gap:'10px',padding:'12px 18px',borderTop:'1px solid #f0f2f7',background:'#f8f9fa',borderRadius:'0 0 16px 16px'},
  row:{display:'flex',gap:'12px',marginBottom:'12px',flexWrap:'wrap'},
  errBox:{background:'#fff3f3',border:'1px solid #ffcdd2',borderRadius:'8px',padding:'10px 14px',color:'#c62828',marginBottom:'10px',fontSize:'13px'},
  warnBox:{background:'#fff8e1',border:'1px solid #ffe082',borderRadius:'8px',padding:'9px 14px',color:'#e65100',marginBottom:'8px',fontSize:'12px'},
  dropdown:{position:'absolute',top:'100%',left:0,right:0,background:'#fff',border:'1px solid #ddd',borderRadius:'8px',maxHeight:'190px',overflowY:'auto',zIndex:50,boxShadow:'0 6px 20px rgba(0,0,0,0.18)'},
  dropItem:{padding:'7px 11px',fontSize:'12px',cursor:'pointer',borderBottom:'1px solid #f5f5f5',textAlign:'right'},
  btnCancel:{padding:'8px 18px',background:'#e0e0e0',color:'#333',border:'none',borderRadius:'8px',cursor:'pointer',fontFamily:'inherit',fontSize:'13px'},
  btnSave:{padding:'8px 22px',background:'linear-gradient(135deg,#1b5e20,#2e7d32)',color:'#fff',border:'none',borderRadius:'8px',cursor:'pointer',fontFamily:'inherit',fontSize:'13px',fontWeight:'700'},
  toast:{position:'fixed',bottom:'24px',right:'24px',background:'#1b5e20',color:'#fff',padding:'12px 24px',borderRadius:'10px',fontSize:'14px',fontWeight:'600',zIndex:2000,boxShadow:'0 4px 16px rgba(0,0,0,0.25)'},
};
